// Mock data for Gameodys website

export const games = {
  current: [
    {
      id: 1,
      name: "Truco",
      description: "Jogue Truco Mineiro e Truco Paulista. Escolha sua modalidade favorita e mostre suas habilidades nas cartas.",
      image: "https://images.unsplash.com/photo-1743677042704-74a8390e765a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwyfHx0cnVjbyUyMGNhcmRzfGVufDB8fHx8MTc3MjIxNzE5NXww&ixlib=rb-4.1.0&q=85",
      status: "available"
    },
    {
      id: 2,
      name: "Sinuca",
      description: "Dispute na Sinuca Tradicional ou na modalidade 9 Bolas. Precisão e estratégia para vencer.",
      image: "https://images.unsplash.com/photo-1556329754-9420aeb663c5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwyfHxwb29sJTIwYmlsbGlhcmRzfGVufDB8fHx8MTc3MjIxNzE5OHww&ixlib=rb-4.1.0&q=85",
      status: "available"
    }
  ],
  upcoming: [
    {
      id: 3,
      name: "Dominó",
      description: "O tradicional jogo de dominó com competições e prêmios.",
      image: "https://images.unsplash.com/photo-1768839722117-da92d4acc9ef?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwyfHxkb21pbm8lMjBwaWVjZXN8ZW58MHx8fHwxNzcyMjE3MjAyfDA&ixlib=rb-4.1.0&q=85",
      status: "coming-soon"
    },
    {
      id: 4,
      name: "Dama",
      description: "Estratégia e habilidade no clássico jogo de damas.",
      image: "https://images.unsplash.com/photo-1610232826230-e5e6c6a1efef?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxjaGVja2VycyUyMGJvYXJkfGVufDB8fHx8MTc3MjIxNzIwNXww&ixlib=rb-4.1.0&q=85",
      status: "coming-soon"
    },
    {
      id: 5,
      name: "Poker",
      description: "Torneios de poker com grandes prêmios para os melhores jogadores.",
      image: "https://images.unsplash.com/photo-1636583133884-fbefc7ac3fb3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwxfHxwb2tlciUyMGNhcmRzfGVufDB8fHx8MTc3MjIxNzIwOHww&ixlib=rb-4.1.0&q=85",
      status: "coming-soon"
    },
    {
      id: 6,
      name: "Puzzle",
      description: "Desafios de lógica e quebra-cabeças para mentes afiadas.",
      image: "https://images.unsplash.com/photo-1663625318127-bd35dd2e6f75?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwzfHxwdXp6bGUlMjBnYW1lfGVufDB8fHx8MTc3MjIxNzIxM3ww&ixlib=rb-4.1.0&q=85",
      status: "coming-soon"
    },
    {
      id: 7,
      name: "Golf",
      description: "Experiência realista de golfe com torneios online.",
      image: "https://images.unsplash.com/photo-1592937238247-cd0090e02f65?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwyfHxnb2xmJTIwY291cnNlfGVufDB8fHx8MTc3MjIxNzIxN3ww&ixlib=rb-4.1.0&q=85",
      status: "coming-soon"
    }
  ]
};

export const updates = [
  {
    id: 1,
    version: "v2.1.0",
    date: "15 de Dezembro, 2025",
    title: "Novo Sistema de Ranking",
    changes: [
      "Implementado sistema de ranking global",
      "Melhorias na estabilidade do servidor",
      "Correções de bugs menores",
      "Otimização de desempenho"
    ]
  },
  {
    id: 2,
    version: "v2.0.5",
    date: "28 de Novembro, 2025",
    title: "Melhorias de Interface",
    changes: [
      "Nova interface de usuário redesenhada",
      "Adicionado modo escuro",
      "Melhorias na experiência mobile",
      "Novas animações e transições"
    ]
  },
  {
    id: 3,
    version: "v2.0.0",
    date: "10 de Novembro, 2025",
    title: "Grande Atualização",
    changes: [
      "Lançamento do jogo Sinuca",
      "Sistema de chat renovado",
      "Novos prêmios e conquistas",
      "Melhorias gerais de segurança"
    ]
  }
];

export const socialLinks = [
  { name: "Instagram", icon: "Instagram", url: "https://www.instagram.com/gameodys/", active: true },
  { name: "X", icon: "X", url: "#", active: true },
  { name: "Discord", icon: "Discord", url: "https://discord.gg/Rdmc5YJt", active: true }
];

export const mission = {
  title: "Nossa Missão",
  subtitle: "Transformando habilidade em oportunidade",
  description: "Na Gameodys, acreditamos que talento e dedicação merecem reconhecimento real. Nossa missão é criar um ecossistema onde jogadores habilidosos possam transformar sua paixão e expertise em ganhos reais, competindo em um ambiente justo, seguro e profissional.",
  values: [
    {
      title: "Meritocracia",
      description: "Valorizamos quem realmente sabe jogar. Suas habilidades determinam seu sucesso.",
      icon: "Trophy"
    },
    {
      title: "Transparência",
      description: "Regras claras, competições justas e pagamentos garantidos.",
      icon: "Shield"
    },
    {
      title: "Comunidade",
      description: "Construímos uma comunidade forte de jogadores apaixonados.",
      icon: "Users"
    }
  ]
};

export const careerPositions = [
  {
    id: 1,
    title: "Desenvolvedor Full Stack",
    department: "Tecnologia",
    location: "Remoto",
    type: "Tempo Integral"
  },
  {
    id: 2,
    title: "Designer UI/UX",
    department: "Design",
    location: "Remoto",
    type: "Tempo Integral"
  },
  {
    id: 3,
    title: "Gerente de Comunidade",
    department: "Marketing",
    location: "Híbrido",
    type: "Tempo Integral"
  }
];
